<script>
	import { createEventDispatcher } from 'svelte';
	export let showModal = false;

	const dispatch = createEventDispatcher();
	let agreed = false;
</script>

<style>
	.backdrop {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		background: rgba(0,0,0,.95);
		z-index: 10;
	}

	.modal {
		color: #fefefe;
		padding: 1rem;
		position: fixed;
		top: 10vh;
		left: 10%;
		width: 75%;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		min-height: 80vh;
		/* background: white; */
		border-radius: 5px;
		z-index: 100;
		box-shadow: 0 2px 8px rgba(0,0,0,.26);
		overflow: scroll;
	}

	header {
		border-bottom: 1px solid #ddd;
	}
</style>

{#if showModal}

<div class="backdrop" on:click={() => dispatch('cancel')} />
<div class="modal">
	<!-- <header>
		<slot name="header"></slot>
	</header> -->
	<slot></slot>


	<footer>
		<slot name="footer">
			<button class="dark" on:click={() => dispatch('close')}>Close</button>
		</slot>
	</footer>
</div>
{/if}
